import FsUtility from "../Lib/Fs.SmartClient.Client/FsUtility";
import { autoinject, Container } from 'aurelia-framework';
import MenuParameter from "../Modules/Core/Scripts/AppServiceContract/MenuParameter";
import MenuData from "../Modules/Core/Scripts/AppServiceContract/MenuData";
import { OpenIdConnect, OpenIdConnectRoles } from "aurelia-open-id-connect";
import { User } from "oidc-client";
import { I18N } from 'aurelia-i18n';
import { EventAggregator } from 'aurelia-event-aggregator';
import UserProfile from "../Modules/Core/Scripts/UserProfile";
import { DialogService } from 'aurelia-dialog';
import { fs } from "../Config/FsConfig";
import CustomContentAppService from '../Modules/Aqs/Scripts/AppServiceContract/CustomContentAppService';

declare var KTToggle: any;
declare var KTApp: any;
declare var KTAppLayoutBuilder: any;
declare var KTThemeMode: any;
declare var KTDialer: any;
declare var KTDrawer: any;
declare var KTMenu: any;
declare var KTImageInput: any;
declare var KTPasswordMeter: any;
declare var KTScroll: any;
declare var KTScrolltop: any;
declare var KTSticky: any;
declare var KTLayoutSearch: any;
declare var KTSwapper: any;

@autoinject
export default class MasterPage {

  public Links: MenuData[];
  public Id: string;
  public Code: string;
  public Root: string;
  public MainParent: MenuData;
  public ParentLast: MenuData;
  public ParentCode: string;
  public OpenIdConnect: OpenIdConnect;
  public i18n: I18N;
  public currentLocale: string;
  public UserProfile: UserProfile;
  public eventAggregator: EventAggregator;
  public changeLocaleSubscribe: any;
  public isshow: boolean = false;
  public showmenu: boolean = false;
  public dropdownsearch: boolean = false;
  public User: User;
  public SwitchbackUserToken: string;
  public ClientBaseUrl: string = fs.Config.ClientBaseUrl;
  LangList: { Code: string, Name: string }[];
  LocaleString: string;
  CurrentPage: string;
  dialogService: DialogService;

  constructor(openIdConnect: OpenIdConnect, i18n: I18N, eventAggregator: EventAggregator, dialogService: DialogService) {
    var self = this;
    this.Links = [];
    this.LangList = [
      { Code: 'th', Name: "ไทย" },
      { Code: 'en', Name: "ENG" }
    ];
    this.i18n = i18n;
    this.eventAggregator = eventAggregator;
    this.changeLocaleSubscribe = this.eventAggregator.subscribe('ChangeLocale', function (response) {
      self.GenerateMenu();
      self.FindFooterContent();
    });
    this.dialogService = dialogService;
    this.SetActivePage();
  }

  attached() {
    KTDialer.init();
    KTDrawer.init();
    KTImageInput.init();
    KTMenu.init();
    KTPasswordMeter.init();
    KTScroll.init();
    KTScrolltop.init();
    KTSticky.init()
    KTSwapper.init();
    KTToggle.init();
    KTApp.init();
    KTAppLayoutBuilder.init();
    KTLayoutSearch.init();
    KTThemeMode.init();
  }

  activate(model: any) {
    var self = this;
    if (model != null) {
      this.Code = model.Code;
      this.Root = model.Root;
      this.currentLocale = sessionStorage.getItem("CurrentSystemLocale");
      var i18nlocale = self.i18n.getLocale();

      if (self.currentLocale == null) {

        self.GetDefaultLocale();
      } else if (self.currentLocale != i18nlocale) {
        self.ChangeLocale(self.currentLocale);
      }
      self.LocaleString = self.currentLocale;


      //this.GenerateMenu();
    }

    //var service = Container.instance.get(AqsMenuAppService) as AqsMenuAppService;
    //service.RetrieveUserProfile().done((result) => {
    //  self.UserProfile = result;
    //}).fail(FsUtility.CommonErrorHandler);

  }

  public GetDefaultLocale() {
    var localeString = "th";
    this.LocaleString = localeString;
    this.ChangeLocale(localeString);
  }

  public Logout() {
    localStorage.setItem("callbackLink", window.location.href);
    this.OpenIdConnect.logout();
  }

  public ChangePassword() {
    localStorage.setItem("callbackLink", window.location.href);
    location.href = "Modules/Core/ChangePasswordPage";
  }

  public show() {
    this.isshow = !this.isshow;
  }

  public showmenumobile() {
    this.showmenu = !this.showmenu;
  }

  public showsearch() {
    this.dropdownsearch = !this.dropdownsearch;
  }

  public ChangeLocale(locale: string) {
    this.i18n.setLocale(locale);
    this.i18n.i18next.changeLanguage(locale);
    document.body.className = "lang-" + locale;
    sessionStorage.setItem("CurrentSystemLocale", locale);
    this.currentLocale = sessionStorage.getItem("CurrentSystemLocale");
    this.eventAggregator.publish('ChangeLocale');
    this.LocaleString = locale;
  }

  public GenerateMenu() {
    var self = this;
    //var service = Container.instance.get(AqsMenuAppService) as AqsMenuAppService;

    //service.GenerateMenu(this.GetMenuCriteria()).done((result) => {
    //  self.Links = result;
    //  var menuData = this.FindMenuData(self.Links, self.Code);

    //  if (menuData != null) {

    //    this.MainParent = this.FindMainParentCode(menuData);
    //  }

    //}).fail(FsUtility.CommonErrorHandler);
  }

  public FooterDatas: any;
  public CustomeContentCode = ["footer-address", "footer-contact", "footer-tel", "footer-link"];
  FindFooterContent() {
    var self = this;
    var service = Container.instance.get(CustomContentAppService) as CustomContentAppService;
    service.LoadCustomContentFooter(this.CustomeContentCode)
      .done((result) => {
        self.FooterDatas = result;
        self.FilterFooter();
      })
      .fail((error) => {
        FsUtility.CommonErrorHandler(error);
      });
  }

  public Address: string;
  public Contact: string;
  public Tel: string;
  public ExtLink: string;
  FilterFooter() {
    var self = this;
    this.Address = self.FooterDatas.find(t => t.Code == "footer-address");
    this.Contact = self.FooterDatas.find(t => t.Code == "footer-contact");
    this.Tel = self.FooterDatas.find(t => t.Code == "footer-tel");
    this.ExtLink = self.FooterDatas.find(t => t.Code == "footer-link");
  }

  FindMenuData(links: MenuData[], code: string): MenuData {
    if (links.length == 0) {
      return null;
    }

    var menuData = links.find(t => t.Code == code);

    if (menuData != null) {
      return menuData;
    } else {
      var result = null;
      for (var i = 0; i < links.length; i++) {
        result = this.FindMenuData(links[i].ChildrenMenu, code);
        if (result != null) {
          break;
        }
      }
      return result;
    }
  }

  FindMainParentCode(menuData: MenuData): MenuData {
    if (menuData == null) {
      return null;
    }

    if (menuData.ParentCode == this.Root || menuData.ParentCode == null) {

      return menuData;
    }
    this.ParentLast = menuData;
    var parentMenu = this.FindMenuData(this.Links, menuData.ParentCode);

    return this.FindMainParentCode(parentMenu);
  }



  private GetMenuCriteria(): MenuParameter {
    var criteria = new MenuParameter();
    criteria.IsShowAll = false;
    criteria.Root = this.Root;
    return criteria;
  }

  detached() {
    this.changeLocaleSubscribe.dispose();
  }

  SetActivePage() {
    var url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    this.CurrentPage = url;
  }
}
